 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		41: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		41: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~layouts__BasicLayout~p__BI~p__Basic__Alarm~p__Basic__Attendance~p__Basic__Calendar~p__Basic_~bfff8ef2","1":"vendors~layouts__BasicLayout~p__BI~p__Basic__Alarm~p__Basic__Attendance~p__Basic__Calendar~p__Basic_~a8a252b8","2":"vendors~layouts__BasicLayout~p__Basic__Alarm~p__Basic__Attendance~p__Basic__Calendar~p__Basic__Chart~a621b5f2","3":"vendors~layouts__BasicLayout~p__Basic__Alarm~p__Basic__Attendance~p__Basic__Calendar~p__Basic__Chart~b3a57b2a","4":"layouts__BasicLayout","5":"layouts__BlankLayout","6":"layouts__SecurityLayout","7":"p__BI","8":"p__Basic__Alarm","9":"p__Basic__Attendance","10":"p__Basic__Calendar","11":"p__Basic__Chart","12":"p__Basic__Detail","13":"p__Basic__History","14":"p__Basic__Log","15":"p__Basic__Omit","16":"p__Basic__Raw","17":"p__Basic__Report","18":"p__Company","19":"p__Dashboard","20":"p__Data__Device","21":"p__Data__Role","22":"p__Data__System","23":"p__Data__User","24":"p__Exception__403","25":"p__Exception__404","26":"p__Exception__500","27":"p__Login","28":"p__RealTimeMap","29":"p__Setup__Book","30":"p__Setup__Content","31":"p__Setup__Dept","32":"p__Setup__DownParam","33":"p__Setup__Duty","34":"p__Setup__Event","35":"p__Setup__Guard","36":"p__Setup__Plan","37":"p__Setup__Receipt","38":"p__Setup__Site","39":"p__Setup__Talk","40":"p__Setup__Voice","42":"vendors~layouts__BlankLayout","43":"vendors~p__BI","44":"vendors~p__Data__System","45":"vendors~p__Login"}[chunkId]||chunkId) + "." + {"0":"47b2642b","1":"4e7d8816","2":"c1776515","3":"c75dd977","4":"8a7e24d4","5":"bf95c72e","6":"4c21bb2b","7":"b047070a","8":"9f7efc22","9":"fd06671c","10":"f9801d08","11":"e0476078","12":"ace95a02","13":"daecbaca","14":"7aa6b4ba","15":"a1777ec7","16":"3cf4c2a8","17":"65fc6663","18":"753fa4eb","19":"767fac77","20":"722a22c1","21":"d21bcaa5","22":"73262922","23":"9ddb3e6d","24":"a80518bd","25":"555c1e97","26":"6e43bb82","27":"2f83c0a9","28":"a863a932","29":"30ab3601","30":"336fe182","31":"95736cef","32":"268aa451","33":"5bb9973d","34":"7f4268a7","35":"27ee13c5","36":"1da58494","37":"cb9fc3e9","38":"3a257f5b","39":"b3f1cd7b","40":"41b78887","42":"fa3a140c","43":"4ec8673d","44":"5aba44a0","45":"1349f10a","46":"1d59f868","47":"f1276f73"}[chunkId] + ".async.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"2":1,"3":1,"4":1,"5":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1,"43":1,"44":1,"45":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"vendors~layouts__BasicLayout~p__BI~p__Basic__Alarm~p__Basic__Attendance~p__Basic__Calendar~p__Basic_~bfff8ef2","1":"vendors~layouts__BasicLayout~p__BI~p__Basic__Alarm~p__Basic__Attendance~p__Basic__Calendar~p__Basic_~a8a252b8","2":"vendors~layouts__BasicLayout~p__Basic__Alarm~p__Basic__Attendance~p__Basic__Calendar~p__Basic__Chart~a621b5f2","3":"vendors~layouts__BasicLayout~p__Basic__Alarm~p__Basic__Attendance~p__Basic__Calendar~p__Basic__Chart~b3a57b2a","4":"layouts__BasicLayout","5":"layouts__BlankLayout","6":"layouts__SecurityLayout","7":"p__BI","8":"p__Basic__Alarm","9":"p__Basic__Attendance","10":"p__Basic__Calendar","11":"p__Basic__Chart","12":"p__Basic__Detail","13":"p__Basic__History","14":"p__Basic__Log","15":"p__Basic__Omit","16":"p__Basic__Raw","17":"p__Basic__Report","18":"p__Company","19":"p__Dashboard","20":"p__Data__Device","21":"p__Data__Role","22":"p__Data__System","23":"p__Data__User","24":"p__Exception__403","25":"p__Exception__404","26":"p__Exception__500","27":"p__Login","28":"p__RealTimeMap","29":"p__Setup__Book","30":"p__Setup__Content","31":"p__Setup__Dept","32":"p__Setup__DownParam","33":"p__Setup__Duty","34":"p__Setup__Event","35":"p__Setup__Guard","36":"p__Setup__Plan","37":"p__Setup__Receipt","38":"p__Setup__Site","39":"p__Setup__Talk","40":"p__Setup__Voice","42":"vendors~layouts__BlankLayout","43":"vendors~p__BI","44":"vendors~p__Data__System","45":"vendors~p__Login"}[chunkId]||chunkId) + "." + {"0":"1ecd6dae","1":"0df548e4","2":"c96decb7","3":"ef0a27c6","4":"85b53a4e","5":"79ac823e","6":"31d6cfe0","7":"85ffb324","8":"877e3b2e","9":"877e3b2e","10":"0ab445dc","11":"877e3b2e","12":"2647dc5f","13":"2647dc5f","14":"877e3b2e","15":"877e3b2e","16":"877e3b2e","17":"f314acf5","18":"3d9f8544","19":"d8b25ace","20":"99de258d","21":"877e3b2e","22":"31d6cfe0","23":"99de258d","24":"79ac823e","25":"79ac823e","26":"79ac823e","27":"d5be6762","28":"456627c3","29":"877e3b2e","30":"ed921dbb","31":"877e3b2e","32":"877e3b2e","33":"877e3b2e","34":"877e3b2e","35":"877e3b2e","36":"e52cb1d7","37":"877e3b2e","38":"db379a4b","39":"877e3b2e","40":"877e3b2e","42":"31d6cfe0","43":"c3cde722","44":"ab3d1b29","45":"89cf2e0a","46":"31d6cfe0","47":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
